var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.236 0c1.652 0 2.94.298 3.866.893.925.595 1.388 1.485 1.388 2.669 0 .601-.173 1.139-.516 1.61-.343.474-.844.83-1.499 1.068.843.167 1.474.523 1.895 1.071.419.55.63 1.183.63 1.903 0 1.245-.444 2.187-1.33 2.825-.886.641-2.144.961-3.769.961H0v-2.167h1.494V2.167H0V0h6.236zM4.308 5.446h2.024c.752 0 1.33-.143 1.734-.43.405-.285.608-.701.608-1.25 0-.6-.204-1.044-.612-1.33-.408-.286-1.016-.427-1.826-.427H4.308v3.437zm0 1.804V11h2.593c.747 0 1.314-.152 1.707-.452.39-.3.588-.745.588-1.334 0-.636-.168-1.124-.5-1.46-.336-.335-.864-.504-1.582-.504H4.308z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldIcon);
export default __webpack_public_path__ + "static/media/bold-icon.130a44587e4605ce31b164c05f0b8ec7.svg";
export { ForwardRef as ReactComponent };